<template>
  <el-main>
    <div id="login">
      <el-form
        :model="user"
        :rules="rules"
        ref="ruleForm"
        @submit.native.prevent="handleLogin('ruleForm')"
      >
        <el-form-item label="ログインID" prop="id">
          <el-input v-model="user.id"></el-input>
        </el-form-item>

        <el-form-item label="パスワード" prop="password">
          <el-input type="password" v-model="user.password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="isChecked">
            <span>入力情報を保存</span>
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-alert
            :title="message"
            :type="successful ? 'success' : 'error'"
            v-if="message != ''"
          ></el-alert>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" native-type="submit">ログイン</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import User from "../models/user";
import store from "../store";

import firebase from "firebase";
import userService from "../services/user.service";

export default {
  name: "Login",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードを入力してください。"));
      } else {
        callback();
      }
    };
    return {
      isChecked: this.$localStorage.get("isSeved", false),
      successful: false,
      user: new User("", "", "", "", "", ""),
      loading: false,
      message: "",
      rules: {
        id: [
          {
            required: true,
            message: "ログインIDを入力してください。",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    isChecked(newValue) {
      console.log(newValue);
      this.$localStorage.set("isSeved", newValue);
    },
  },
  computed: {
    loggedIn() {
      return store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push({ name: "top" });
    }
  },
  async mounted() {
    await this.$nextTick();
    if (this.$localStorage.get("isSeved")) {
      this.user.id = this.$localStorage.get("id", "");
      this.user.password = this.$localStorage.get("password", "");
    }
  },
  methods: {
    async handleLogin(formName) {
      this.loading = true;
      const self = this;
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          this.loading = false;
          return;
        }
        console.log("singin");
        console.log(this.user);
        if (this.user.id && this.user.password) {
          try {
            const result = await this.$store.dispatch("auth/login", this.user);
            console.log(result);
            if (self.$localStorage.get("isSeved")) {
              self.$localStorage.set("id", self.user.id);
              self.$localStorage.set("password", self.user.password);
            } else {
              self.$localStorage.set("id", "");
              self.$localStorage.set("password", "");
            }

            console.log("+++A");
            let messaging = null;
            if (firebase.messaging.isSupported()) {
              console.log("+++B");
              messaging = firebase.messaging();
              messaging
                .getToken({
                  vapidKey: `${process.env.VUE_APP_FIREBASE_VAPID_KEY}`,
                })
                .then(currentToken => {
                  console.log("+++C");
                  if (currentToken) {
                    console.log(`login currentToken=${currentToken}`);
                    userService.setToken(currentToken);
                    console.log("++OK");

                    this.$router.push({ name: "top" });
                  } else {
                    // Show permission request.
                    console.log(
                      "No registration token available. Request permission to generate one.",
                    );
                    // Show permission UI.
                    // updateUIForPushPermissionRequired();
                    // setTokenSentToServer(false);
                    this.$router.push({ name: "top" });
                  }
                })
                .catch(err => {
                  console.log(
                    "An error occurred while retrieving token. ",
                    err,
                  );

                  this.$router.push({ name: "top" });
                  // showToken("Error retrieving registration token. ", err);
                  // setTokenSentToServer(false);
                });
            } else {
              this.$router.push({ name: "top" });
            }
          } catch (error) {
            console.log(error);
            console.log("singin erro!");
            this.successful = false;
            this.loading = false;
            console.log(error);
            this.message = "ログインできませんでした。";
          }
        }
      });
    },
    // handleLogin(formName) {
    //   this.loading = true;
    //   const self = this;
    //   this.$refs[formName].validate(valid => {
    //     if (!valid) {
    //       this.loading = false;
    //       return;
    //     }
    //     console.log("singin");
    //     console.log(this.user);
    //     if (this.user.id && this.user.password) {
    //       this.$store.dispatch("auth/login", this.user).then(
    //         () => {
    //           if (self.$localStorage.get("isSeved")) {
    //             self.$localStorage.set("id", self.user.id);
    //             self.$localStorage.set("password", self.user.password);
    //           } else {
    //             self.$localStorage.set("id", "");
    //             self.$localStorage.set("password", "");
    //           }

    //           console.log("+++A");
    //           let messaging = null;
    //           if (firebase.messaging.isSupported()) {
    //             console.log("+++B");
    //             messaging = firebase.messaging();
    //             messaging
    //               .getToken({
    //                 vapidKey: `${process.env.VUE_APP_FIREBASE_VAPID_KEY}`,
    //               })
    //               .then(currentToken => {
    //                 console.log("+++C");
    //                 if (currentToken) {
    //                   console.log(`login currentToken=${currentToken}`);
    //                   userService.setToken(currentToken);
    //                   console.log("++OK");

    //                   this.$router.push({ name: "top" });
    //                 } else {
    //                   // Show permission request.
    //                   console.log(
    //                     "No registration token available. Request permission to generate one.",
    //                   );
    //                   // Show permission UI.
    //                   // updateUIForPushPermissionRequired();
    //                   // setTokenSentToServer(false);
    //                   this.$router.push({ name: "top" });
    //                 }
    //               })
    //               .catch(err => {
    //                 console.log(
    //                   "An error occurred while retrieving token. ",
    //                   err,
    //                 );

    //                 this.$router.push({ name: "top" });
    //                 // showToken("Error retrieving registration token. ", err);
    //                 // setTokenSentToServer(false);
    //               });
    //           } else {
    //             this.$router.push({ name: "top" });
    //           }
    //         },
    //         error => {
    //           console.log("singin erro!");
    //           this.successful = false;
    //           this.loading = false;
    //           console.log(error);
    //           // this.message =
    //           //   (error.response &&
    //           //     error.response.data &&
    //           //     error.response.data.message) ||
    //           //   error.message ||
    //           //   error.toString();
    //           this.message = "ログインできませんでした。";
    //         },
    //       );
    //     }
    //   });
    // },
  },
};
</script>

<style></style>
